export default "__VITE_ASSET__CZgyncs$__"